import { Component, Input } from '@angular/core';
import { FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { InputStepperComponent } from '../input-stepper/input-stepper.component';


@Component({
    selector: 'form-number-range-stepper',
    imports: [
        ReactiveFormsModule,
        InputStepperComponent,
    ],
    template: `
        <div class="form-group" [class.is-invalid]="controlFrom.invalid || controlTo.invalid">
            <ng-content select="label"></ng-content>
            <ng-content select="i.fa"></ng-content>
            <div class="form-range">
                <input-stepper [attr.id]="formControlFrom" [min]="0" [max]="maxInt64" [formControl]="controlFrom">
                    <span class="input-group-prepend">
                        <span class="input-group-text">Min</span>
                    </span>
                </input-stepper>
                <span class="dash">&ndash;</span>
                <input-stepper [attr.id]="formControlTo" [min]="0" [max]="maxInt64" [formControl]="controlTo">
                    <span class="input-group-prepend">
                        <span class="input-group-text">Max</span>
                    </span>
                </input-stepper>
                <ng-content></ng-content>
            </div>
            <small class="invalid-feedback">Please enter positive number</small>
            <ng-content select="small.form-text"></ng-content>
        </div>
    `,
})
export class FormNumberRangeStepperComponent {

    @Input() formControlFrom: string;

    @Input() formControlTo: string;

    maxInt64 = Number.MAX_SAFE_INTEGER;

    get controlFrom() {
        return this.formGroup.control.get(this.formControlFrom) as FormControl;
    }

    get controlTo() {
        return this.formGroup.control.get(this.formControlTo) as FormControl;
    }

    constructor(public formGroup: FormGroupDirective) {}
}
